import React from 'react';
import { useTranslation } from 'react-i18next';

const WhatWeOffer = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-[#EDEDED] w-full px-5 sm:px-6 xl:px-8 py-[63px] md:py-20">
      <div className="max-w-[1300px] mx-auto w-full">
        <div className="max-w-[380px] w-full md:text-left text-center">
          <h2 className="text-[#1D1D1F] text-[32px] sm:text-[46px] leading-[40px] sm:leading-[57px] libre-baskerville font-normal mb-6">
            {t('home.offer.title')}
          </h2>
          <p className="text-[#6E6E73] text-[16px] sm:text-[17px] leading-[22px] sm:leading-[23px] font-medium">
            {t('home.offer.subtitle')}
          </p>
        </div>

        <div className="mt-[35px] md:mt-14 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {/* Workwear */}
          <div>
            <div className="rounded-[10px] h-[500px] relative bg-white overflow-hidden flex items-center justify-center">
              <img
                src="/assets/workwear.webp"
                alt="workwear"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-[33px] sm:bottom-[38px] left-[33px] right-[33px] z-10">
                <h2 className="text-white text-[22px] leading-[28px] font-normal libre-baskerville mb-2">
                  {t('home.offer.workwear.title')}
                </h2>
                <p className="text-[#CCCCCC] text-[14px] leading-[24px] font-medium">
                  {t('home.offer.workwear.description')}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-center">
              <a
                href="/workwear"
                className="mt-5 bg-black h-[57px] rounded-[9px] px-6 text-white flex items-center gap-2.5 inter text-[16px] leading-[16px]"
              >
                {t('home.offer.workwear.cta')}
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  className="mt-[2px]"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.50016 12.7467L12.6668 9.58L9.50016 6.41333L8.39183 7.52166L9.6585 8.78833H6.3335V10.3717H9.6585L8.39183 11.6383L9.50016 12.7467ZM9.50016 17.4967C8.40502 17.4967 7.37586 17.2888 6.41266 16.8732C5.44947 16.4576 4.61162 15.8935 3.89912 15.181C3.18662 14.4685 2.62256 13.6307 2.20693 12.6675C1.79131 11.7043 1.5835 10.6751 1.5835 9.58C1.5835 8.48486 1.79131 7.45569 2.20693 6.4925C2.62256 5.5293 3.18662 4.69145 3.89912 3.97896C4.61162 3.26645 5.44947 2.70239 6.41266 2.28677C7.37586 1.87114 8.40502 1.66333 9.50016 1.66333C10.5953 1.66333 11.6245 1.87114 12.5877 2.28677C13.5509 2.70239 14.3887 3.26645 15.1012 3.97896C15.8137 4.69145 16.3778 5.5293 16.7934 6.4925C17.209 7.45569 17.4168 8.48486 17.4168 9.58C17.4168 10.6751 17.209 11.7043 16.7934 12.6675C16.3778 13.6307 15.8137 14.4685 15.1012 15.181C14.3887 15.8935 13.5509 16.4576 12.5877 16.8732C11.6245 17.2888 10.5953 17.4967 9.50016 17.4967Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>

          {/* Paints */}
          <div>
            <div className="rounded-[10px] h-[500px] relative bg-white overflow-hidden flex items-center justify-center">
              <img
                src="/assets/paints.webp"
                alt="paints"
                className="w-full h-full object-cover sm:block hidden"
              />
              <img
                src="/assets/paints-mobile.webp"
                alt="paints"
                className="w-full h-full sm:hidden block"
              />

              <div className="absolute bottom-[33px] sm:bottom-[38px] left-[33px] right-[33px] z-10">
                <h2 className="text-white text-[22px] leading-[28px] font-normal libre-baskerville mb-2">
                  {t('home.offer.paints.title')}
                </h2>
                <p className="text-[#CCCCCC] text-[14px] leading-[24px] font-medium">
                  {t('home.offer.paints.description')}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-center">
              <a
                href="/paints"
                className="mt-5 bg-black h-[57px] rounded-[9px] px-6 text-white flex items-center gap-2.5 inter text-[16px] leading-[16px]"
              >
                {t('home.offer.paints.cta')}
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  className="mt-[2px]"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.50016 12.7467L12.6668 9.58L9.50016 6.41333L8.39183 7.52166L9.6585 8.78833H6.3335V10.3717H9.6585L8.39183 11.6383L9.50016 12.7467ZM9.50016 17.4967C8.40502 17.4967 7.37586 17.2888 6.41266 16.8732C5.44947 16.4576 4.61162 15.8935 3.89912 15.181C3.18662 14.4685 2.62256 13.6307 2.20693 12.6675C1.79131 11.7043 1.5835 10.6751 1.5835 9.58C1.5835 8.48486 1.79131 7.45569 2.20693 6.4925C2.62256 5.5293 3.18662 4.69145 3.89912 3.97896C4.61162 3.26645 5.44947 2.70239 6.41266 2.28677C7.37586 1.87114 8.40502 1.66333 9.50016 1.66333C10.5953 1.66333 11.6245 1.87114 12.5877 2.28677C13.5509 2.70239 14.3887 3.26645 15.1012 3.97896C15.8137 4.69145 16.3778 5.5293 16.7934 6.4925C17.209 7.45569 17.4168 8.48486 17.4168 9.58C17.4168 10.6751 17.209 11.7043 16.7934 12.6675C16.3778 13.6307 15.8137 14.4685 15.1012 15.181C14.3887 15.8935 13.5509 16.4576 12.5877 16.8732C11.6245 17.2888 10.5953 17.4967 9.50016 17.4967Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatWeOffer;
